module.exports = __webpack_public_path__ + "static/media/QUALITYASSURANCE.9ae04ef3.png";